import { makeStyles } from "@material-ui/core";

const useTicketStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: "100%",
    position: "relative",
    overflow: "hidden",
  },

  /** Área chat: clic cabecera abre perfil 360 en panel derecho (`ContactProfile360Modal` Drawer, 0287). */
  mainWrapper: {
    flex: 1,
    height: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    position: "relative",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    borderLeft: "0",
    backgroundColor: theme.mode === "dark" ? "#111827" : "#f5f5f5",
  },
}));

export default useTicketStyles;
